import { generate, type ToVariants } from '@/components/experiments/Core/generateBasicExperimentComponent';

// ?preferred_variant=APPLE_PROMOTION_ROW_2:control
// ?preferred_variant=APPLE_PROMOTION_ROW_2:variant_1

export const ApplePromotionRowName = 'APPLE_PROMOTION_ROW_2' as const;

export type ApplePromotionRowVariants = ToVariants<typeof ApplePromotionRowVariants>;

export const ApplePromotionRowVariants = {
	/** Standard promotion row. */
	CONTROL: 'control',

	/** Larger "card" promotion row for Apple TV+. */
	VARIANT_1: 'variant_1',
} as const;

export default generate(ApplePromotionRowName, ApplePromotionRowVariants);
